import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const SERVICES = [
  { key: "websites", label: "Websites",
    body: "Modern, high-performing websites built to make businesses look professional and generate real opportunities." },
  { key: "software", label: "Software",
    body: "Custom digital tools built around how your business actually operates." },
  { key: "systems", label: "Systems",
    body: "Digital infrastructure that simplifies how businesses work day-to-day." },
  { key: "support", label: "Support",
    body: "Hosting, maintenance and ongoing improvements, handled by us." },
];

export default function Services() {
  const [hovered, setHovered] = useState(null);
  return (
    <section id="services" data-testid="services-section" className="relative bg-[color:var(--ww-cream)] pt-20 md:pt-32 pb-20 md:pb-32 noise">
      <div className="max-w-[92rem] mx-auto px-5 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-8">
        <div className="md:col-span-4">
          <p className="text-[11px] uppercase tracking-[0.28em] text-black/50 font-medium font-body">What we do</p>
          <h2 className="mt-6 font-display font-bold uppercase text-5xl sm:text-6xl md:text-7xl leading-[0.94] tracking-tight text-[color:var(--ww-charcoal)]">
            More than <span className="text-brand-gradient">websites.</span>
          </h2>
          <p className="mt-6 max-w-xs text-black/55 leading-relaxed font-body">Four disciplines, one team. Hover a row to focus in.</p>
        </div>
        <ul className="md:col-span-8 divide-y divide-black/10 border-y border-black/10" onMouseLeave={() => setHovered(null)}>
          {SERVICES.map((s, i) => {
            const active = hovered === s.key;
            const dim = hovered && hovered !== s.key;
            return (
              <li key={s.key} data-testid={`service-row-${s.key}`} onMouseEnter={() => setHovered(s.key)}
                className={`group relative transition-opacity duration-300 ${dim ? "opacity-40" : "opacity-100"}`}>
                <div className="grid grid-cols-12 items-center gap-4 md:gap-6 py-8 md:py-10">
                  <span className="col-span-2 md:col-span-1 font-mono text-xs text-black/45">0{i + 1}</span>
                  <motion.h3 animate={{ x: active ? 12 : 0 }} transition={{ type: "spring", stiffness: 220, damping: 26 }}
                    className="col-span-10 md:col-span-4 font-display font-bold uppercase text-4xl sm:text-5xl md:text-6xl leading-none tracking-tight text-[color:var(--ww-charcoal)]">
                    {s.label}<span className="text-brand-gradient">.</span>
                  </motion.h3>
                  <p className="col-start-3 md:col-start-6 col-span-10 md:col-span-6 text-sm md:text-[15px] text-black/60 leading-relaxed max-w-md font-body">{s.body}</p>
                  <motion.span animate={{ opacity: active ? 1 : 0.35, x: active ? 0 : -8 }}
                    className="hidden md:inline-grid col-span-1 place-items-center w-10 h-10 rounded-full border border-black/15 text-black">
                    <ArrowUpRight className="w-4 h-4" />
                  </motion.span>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
